import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const NotificationIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22 22"
    >
      <g transform="translate(1 1)">
        <path
          d="M1283.6,81.25h8.776V87.5l5.6-6.25h5.626V67.5h-20Z"
          transform="translate(-1283.597 -67.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
